// src/components/Header.js
import React, { useState, useEffect } from "react";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={scrolled ? "scrolled" : ""}>
      <nav className="navbar">

        {/* Logo */}
        <div className="logo-wrap">
          <div className="logo-icon">M</div>
          <div className="logo-text">Mech<span>Folks</span></div>
        </div>

        {/* Nav Links */}
        <ul className={menuOpen ? "nav-links active" : "nav-links"}>
          <li><a href="#home" onClick={closeMenu}>Home</a></li>
          <li><a href="#about" onClick={closeMenu}>About</a></li>
          <li><a href="#services" onClick={closeMenu}>Services</a></li>
          <li><a href="#why-us" onClick={closeMenu}>Why Us</a></li>
          <li><a href="#insights" onClick={closeMenu}>Architecture</a></li>
          <li><a href="#contact" onClick={closeMenu}>Contact</a></li>
        </ul>

        {/* Right Section */}
        <div className="nav-cta">
          <div className="nav-social">
            <a href="https://www.linkedin.com/in/mechfolks-technologies-b10b753b5" target="_blank" rel="noreferrer">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://www.instagram.com/mechfolks_technologies/" target="_blank" rel="noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://github.com/infomechfolkstechnologies-bot" target="_blank" rel="noreferrer">
              <i className="fab fa-github"></i>
            </a>
          </div>
          <a href="#contact" className="nav-btn">Get a Quote</a>
        </div>

        {/* Hamburger */}
        <div className={`hamburger ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

      </nav>
    </header>
  );
}

export default Header;
